import script from "./AboutIranPhonics.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutIranPhonics.vue?vue&type=script&setup=true&lang=js"

import "./AboutIranPhonics.vue?vue&type=style&index=0&id=173fd208&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173fd208"]])

export default __exports__